const allowedEnvs = ['production', 'staging', 'test-1', 'test-2', 'local'];

// Obtenemos el modo directamente desde VUE CLI (--mode production) o NODE_ENV
const rawEnv = process.env.NODE_ENV || 'production';

// Validamos que sea un entorno permitido
const name = allowedEnvs.includes(rawEnv) ? rawEnv : 'production';

export const environment = {
  name,
};
